import { KeyboardEvent, useRef } from 'react';

/**
 * Props for a `StyledReactSelect` inside the Edit questions dialog. react-select
 * closes its menu on Escape and lets the keydown bubble on to the dialog, which
 * closes on Escape and drops the unsaved form with it. With these, the menu
 * swallows the Escape that closes it, and the next one reaches the dialog.
 */
export const useMenuEscapeGuard = () => {
  const menuOpen = useRef(false);

  return {
    onKeyDown: (event: KeyboardEvent<HTMLDivElement>) => {
      if (event.key === 'Escape' && menuOpen.current) event.stopPropagation();
    },
    onMenuOpen: () => {
      menuOpen.current = true;
    },
    onMenuClose: () => {
      menuOpen.current = false;
    },
  };
};
